var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Für dich"}}),_c('div',{staticClass:"container py-2"},[_c('recommendation-index',{attrs:{"event-short-name":_vm.shortName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }